export const Messages = {
  REGISTRATION: 'Registration successful.',
  SIGNUP_SUCCESS: 'You will receive an acknowledgement mail shortly. ',
  INVALID_ORG: 'Invaild Organisation',
  UNSAVED_CHANGES:
    'You may have unsaved changes. Are you sure you want to leave?',
  VALID_MIN_MAX: 'Please enter a valid min/max range',
  DELETE_PLANT: 'Are you sure want to remove the plant?',
  REMOVE_CONFIG: 'Are you sure want to remove Configuration?',
  DELETE_SUCCESS: 'Deleted Successfully',
  DELETE_FAILED: 'Delete Operation Failed',
  TAB_SYSTEM: 'system',
  TAB_GLOBAL: 'global',
  TAB_TENANT: 'tenant',
  TAB_SITE: 'site',
  SUCCESS: 'success',
  ERROR: 'error',
  VIEW: 'view',
  EDIT: 'edit',
  DELETE: 'delete',
  DOWNLOAD: 'download',
  ASSIGN_PLANT: 'attach',
  DELETE_ALERT: 'Are you sure want to delete alert Id: ',
  DELETE_RULE: 'Are you sure want to remove the Role?',
  DELETE_TRADE: 'Are you sure want to remove the Trade?',
  DELETE_FEATURE: 'Are you sure want to remove the Feature?',
  DELETE_OTA: 'Are you sure want to remove the Device app ota?',
  DELETE_ERRORCODE: 'Are you sure want to remove the Error Code?',
  DELETE_USER:
    'All Plant, Zones, Supervisor and Device allocations will be removed for this user while deleting, do you want to continue?',
  IMAGE_DELETE: 'Image will be deleted permanently. Are you sure?',
  DELETE_ZONE: 'Are you sure want to remove the zone?',
  SUBMIT_UNSAVED_CHANGES: 'Do you want to save the changes?',
  DELETE_KNOWLEDGE_BASE:
    'Are you sure want to remove the knowledge base entry?',
  DELETE_FILE_FAILED: 'File Delete Operation Failed',
  ADD: 'add',
  EDIT_USER: 'Do you  want to save changes?',
  REJECT_USER: 'Are you sure you want to reject the user?',
  REVOKE_PASSWORD: 'Are you sure you want to revoke password?',
  RESET_PASSWORD: 'Are you sure you want to reset password?',
  KBASE_UPLOAD_FORM_TITLE: 'Upload Document',
  KBASE_UPLOAD_FORM_TITLE_REQUIRED: 'Please enter a title',
  KBASE_UPLOAD_FORM_AREA_REQUIRED: 'Please select an area',
  KBASE_UPLOAD_FORM_CATEGORY_REQUIRED: 'Please select a category',
  KBASE_UPLOAD_FORM_FILE_REQUIRED: 'Please select a file',
  KBASE_UPLOAD_FORM_FILE_INVALID_SIZE:
    'Please select a file less than [SIZE]MB',
  KBASE_UPLOAD_FORM_FILE_INVALID_TYPE: 'Please select a file in valid format',
  KBASE_UPLOAD_FORM_THUMBNAIL_INVALID_SIZE:
    'Please select a file less than [SIZE]MB',
  KBASE_UPLOAD_FORM_THUMBNAIL_INVALID_TYPE:
    'Please select a file in valid format',
  KBASE_UPLOAD_FORM_FILE_VALID_EXTENSION:
    'doc, docx, pdf, ppt, pptx, xls, xlsx, mp4, mp3, jpeg, jpg or png',
  KBASE_UPLOAD_FORM_THUMBNAIL_VALID_EXTENSION: 'in jpeg, jpg or png',
  SELECT_SITE: 'Select Site to continue!',
  ACCEPT_USER: 'Are you sure you want to approve the user?',
  OVERALL_STATUS: 'Overall Status',
  MODULEHEALTH_TOTALMODULES_LABEL: 'Total Modules',
  MODULEHEALTH_TOTALMODULES_CATEGORY: 'Module',
  MODULEHEALTH_MODULES_CATEGORY: 'Status',
  ASSETCONDITION_TOOLTIP:
    'Asset safe within [LOWER_LIMIT]°F and [UPPER_LIMIT]°F',
  THRESHOLDEDIT_EDIT_LABEL: 'Edit Threshold',
  THRESHOLDEDIT_FORM_ERROR_LOWERLIMIT:
    'Lower threshold should be less than or equal to upper threshold',
  THRESHOLDEDIT_FORM_ERROR_REQUIRED: 'Please enter threshold value',
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  HISTORY_STATUS: 'Description: [HISTORY_OF] is [STATUS]',
  NOT_RECOGNIZED: 'not recognized*',
  TODAY: 'Today',
  THIS_WEEK: 'This Week',
  NEXT_WEEK: 'Next Week',
  MORE_PLUS: 'More +',
  DISTANCE: 'Distance',
  TIME_TAKEN: 'Time Taken',
  NOW: 'Now',
  ALERTPROFILEVIEW: 'alertProfile',

  // Zone
  ZONE_LIST_EXPAND_HOVER_LABEL: 'Click here to expand/collapse the view',
  ZONE_LIST_FLOOR_PLAN_TOOLTIP: 'View Floor Plan of [ZONE]',
  ZONE_LIST_TOTAL_ASSETS_TOOLTIP: 'Total Assets: [COUNT]',
  ZONE_LIST_TOTAL_DEVICES_TOOLTIP: 'Total Devices: [COUNT]',
  ZONE_LIST_TOTAL_CHILD_ZONE_TOOLTIP: 'Total [ZONE]: [COUNT]',

  // Zone Modal Form
  ZONE_FORM_NAME_LABEL: 'Name',
  ZONE_FORM_NAME_REQUIRED: 'Name is required',
  ZONE_FORM_NAME_PATTERN: 'Remove white space from start and end',
  ZONE_FORM_LABEL_COLOR_LABEL: 'Label Color',
  ZONE_FORM_LABEL_COLOR_REQUIRED: 'Color is required',
  ZONE_FORM_LEVEL_LABEL: 'Level',
  ZONE_FORM_LEVEL_REQUIRED: 'Level is required',
  ZONE_FORM_LATITUDE_LABEL: 'Latitude',
  ZONE_FORM_LATITUDE_REQUIRED: 'Latitude is required',
  ZONE_FORM_LATITUDE_PATTERN: 'Please enter less than 5 decimal point',
  ZONE_FORM_LONGITUDE_LABEL: 'Longitude',
  ZONE_FORM_LONGITUDE_REQUIRED: 'Longitude is required',
  ZONE_FORM_LONGITUDE_PATTERN: 'Please enter less than 5 decimal point',
  ZONE_FORM_RISK_TYPE_LABEL: 'Risk Type',
  ZONE_FORM_RISK_TYPE_REQUIRED: 'Risk Type is required',
  ZONE_FORM_FLOOR_HEIGHT_LABEL: 'Floor Height',
  ZONE_FORM_FLOOR_HEIGHT_REQUIRED: 'Floor Height is required',
  ZONE_FORM_MAX_PRESSURE_LABEL: 'Max Pressure',
  ZONE_FORM_MAX_PRESSURE_REQUIRED: 'Max Pressure is required',
  ZONE_FORM_MAX_PRESSURE_PATTERN: 'Please enter less than 5 decimal point',
  ZONE_FORM_ALTITUDE_LABEL: 'Altitude',
  ZONE_FORM_ALTITUDE_REQUIRED: 'Altitude is required',
  ZONE_FORM_ALTITUDE_PATTERN: 'Please enter less than 5 decimal point',
  ZONE_FORM_MIN_PRESSURE_LABEL: 'Min Pressure',
  ZONE_FORM_MIN_PRESSURE_REQUIRED: 'Min Pressure is required',
  ZONE_FORM_MIN_PRESSURE_PATTERN: 'Please enter less than 5 decimal point',
  ZONE_FORM_STROKE_OPACITY_LABEL: 'Stroke Opacity',
  ZONE_FORM_STROKE_OPACITY_REQUIRED: 'Stroke Opacity is required',
  ZONE_FORM_STROKE_WEIGHT_LABEL: 'Stroke Weight',
  ZONE_FORM_STROKE_WEIGHT_REQUIRED: 'Stroke Weight is required',
  ZONE_FORM_FILL_COLOR_LABEL: 'Fill Color',
  ZONE_FORM_FILL_COLOR_REQUIRED: 'Fill Color is required',
  ZONE_FORM_FILL_OPACITY_LABEL: 'Fill Opacity',
  ZONE_FORM_FILL_OPACITY_REQUIRED: 'Fill Opacity is required',
  ZONE_FORM_SELECT_HIERARCHY_LABEL: 'Select Hierarchy',
  ZONE_FORM_SELECT_HIERARCHY_REQUIRED: 'Select Hierarchy is required',
  ZONE_FORM_RESTRICTED_ENTRY_ACCESS_LABEL: 'Restricted Entry Access',
  ZONE_FORM_APPLY_TO_CHILD_ZONE_LABEL: 'Apply to ChildZone',
  ZONE_FORM_START_TIME_LABEL: 'Start Time',
  ZONE_FORM_END_TIME_LABEL: 'End Time',
  ZONE_FORM_TIME_ZONE_LABEL: 'End Time',
  ZONE_FORM_TIME_ZONE_REQUIRED: 'Time Zone is required',
  ZONE_FORM_STACK_LABEL: 'Stack',
  ZONE_FORM_STACK_REQUIRED: 'Stack is required',
  ZONE_FORM_AVAILABLE_POSITIONS_LABEL: 'Available Positions',
  ZONE_FORM_AVAILABLE_POSITIONS_REQUIRED: 'Available Positions is required',

  // Zone Plan
  ZONE_PLAN_IMAGE_ALT: 'Floor Plan of [ZONE]',
  ZONE_PLAN_MAPPED_LABEL: 'Tagged Devices',
  ZONE_PLAN_AVAILABLE_LABEL: 'Untagged Devices',
  ZONE_PLAN_LAST_ACTIVE_TIME_LABEL: 'Last Active:',
  ZONE_PLAN_RELATIONAL_ENTITY_LABEL: 'Relational Entity',
  ZONE_PLAN_ENTITY_COUNT_LABEL: 'Count:',
  ZONE_PLAN_ALERT_LABEL: 'Alerts:',
  ZONE_PLAN_DIALOG_DELETE_TITLE: 'Delete Plotting Point',
  ZONE_PLAN_DIALOG_DELETE_CONTENT:
    'Are you sure you want to delete plotting point?',
  ZONE_PLAN_DIALOG_DELETE_TITLE_WORKBENCH: 'Untag Workbench',
  ZONE_PLAN_DIALOG_DELETE_CONTENT_WORKBENCH:
    'The workbench will be untagged from the zone. Do you want to proceed?',
  ZONE_PLAN_DIALOG_DELETE_WORKTABLE: 'Delete Worktable',
  ZONE_PLAN_DIALOG_DELETE_WORKTABLE_CONTENT: 'Are you sure you want to delete',
  ZONE_PLAN_BACK_BUTTON_LABEL: 'Back To Tree View',
  ZONE_PLAN_DRAWER_ENTITY_LABEL: 'Entity',
  ZONE_PLAN_DRAWER_CATEGORY_LABEL: 'Category',
  ZONE_PLAN_DRAWER_ALERT_LABEL: 'Alert',
  ZONE_PLAN_DIALOG_UNTAG_CAMERA_TITLE: 'Untag Device from Work Bench',
  ZONE_PLAN_DIALOG_UNTAG_CAMERA_CONTENT: 'Are you sure you want to untag',

  // Button
  BUTTON_LABEL_RESET: 'Reset',
  BUTTON_LABEL_SUBMIT: 'Submit',
  BUTTON_LABEL_UPDATE: 'Update',
  BUTTON_LABEL_OK: 'Ok',
  BUTTON_LABEL_YES: 'Yes',
  BUTTON_LABEL_NO: 'No',
  BUTTON_LABEL_CANCEL: 'Cancel',
  BUTTON_LABEL_VIEW: 'View',
  BUTTON_LABEL_EDIT: 'Edit',
  BUTTON_LABEL_DELETE: 'Delete',
  BUTTON_LABEL_CLOSE: 'Close',
  BUTTON_LABEL_FILTER: 'Filter',
  BUTTON_LABEL_MAP_FEATURE: 'Map Feature',
  BUTTON_LABEL_ALERT: 'Alert',
  BUTTON_LABEL_BACK: 'Back',
  BUTTON_LABEL_NEXT: 'Next',
  BUTTON_LABEL_ZONE_PLAN_VIEW_MARKER: 'View Marker Location',
  BUTTON_LABEL_ZONE_PLAN_EDIT_MARKER: 'Edit Marker Location',
  BUTTON_LABEL_ZONE_PLAN_UNTAG_MARKER: 'Untag Marker',
  BUTTON_LABEL_ZONE_PLAN_ACTIVE_ALERT: 'Acive Alerts: [COUNT]',
  BUTTON_LABEL_ZONE_PLAN_EXIT_VIEW: 'Exit View Mode',
  BUTTON_LABEL_ZONE_PLAN_APPLY: 'Save Marker Location',
  BUTTON_LABEL_ZONE_PLAN_TAG_MARKER: 'Tag Device',
  BUTTON_LABEL_ZONE_PLAN_TAG_CAMERA: 'Tag Camera',
  BUTTON_LABEL_ZONE_PLAN_UNTAG_CAMERA: 'Untag Camera',

  // Default text
  TEXT_NA: 'NA',
  TEXT_NO_RECORDS: 'No records found',
  TEXT_ADD: 'Add',
  TEXT_UPDATE: 'Update',
  TEXT_EDIT: 'Edit',
  TEXT_ENTITY_VEHICLE: 'Vehicle',
  TEXT_ENTITY_ASSET: 'Asset',
  TEXT_ENTITY_PEOPLE: 'People',
  TEXT_DTC: 'DTC',
  TEXT_ALERTPROFILE: 'Alert Profile',

  // Dialog
  DIALOG_TITLE_DEFAULT: 'Dialog',
  DIALOG_TITLE_ALERT: 'Alert',

  // View switcher
  VIEW_SWITCHER_VIEW_ALL: 'View All',

  // Entity onboard
  ENTITY_ONBOARD_TITLE: '[STATUS] [ENTITY_NAME]',
  ENTITY_ONBOARD_SUBTITLE:
    'Please fill the required fields to [STATUS] a new [ENTITY_NAME]',
  ENTITY_ONBOARD_BUTTON_DISABLE_TOOLTIP: 'Select site to enable add feature',
  ENTITY_ONBOARD_DIALOG_SUCCESS_TITLE: 'Success!',
  ENTITY_ONBOARD_DIALOG_ERROR_TITLE: 'Error!',
  ERROR_PRESIGNED_URL : 'Error fetching Presigned URL',

  //Rules
  SCENARIO_DELETE_DIALOG_TITLE: 'Delete Scenario',
  DELETE_SCENARIO: 'Are you sure you want to delete scenario: [SCENARIO_NAME]?',

  // Form
  FORM_VALIDATOR_REQUIRED_MESSAGE: 'Please fill out the [FIELD_NAME]',
  FORM_VALIDATOR_VALID_MESSAGE: 'Please fill out with valid [VALIDATOR]',

  // Protus
  OPTION_DELETE_DIALOG_TITLE: 'Delete Option',
  DELETE_OPTION: 'Are you sure you want to delete option: [OPTION_NAME]?',
  NO_IDM_USERNAME: '[PROTUS_NAME] creation requires an IDM ID. Update profile to proceed'
};
